export class Trpdbvoucherdetail {
    public VOUCHER_DETAIL_ID!: number;
    public V_NO!: string;
    public V_Date!: string;
    public SNO!: number;
    public TOPDOWN!: string;
    public LEDGER_CODE!: string;
    public DISPLAY_LEDGER_CODE!: string;
    public AMT!: number;
    public CrDr!: string;
    public NARRATION!: string;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE!: boolean;
}